import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import { closeCreateAndUpdateSubZonesForm } from "../../actions/campaign-planning/ZonesAndSubZonesActions";

// Constants
import { FormDataTargets } from "../../../constants/GeneralConstants";

// Components
import ChipsInput from "../../../components/chips-input/ChipsInput";

/**
 * Form-Modal for CreateAndUpdateSubZonesForm
 */
export default function CreateAndUpdateSubZonesForm({
  zoneName,
  onSubmit = () => {},
}) {
  const dispatch = useDispatch();

  // state
  const [subZonesItems, setSubZonesItems] = useState([]);

  // Selector
  const subZones = useSelector((state) => state.zonesAndSubZones.subZones);
  const subZonesInfo = subZones?.[0] || {};
  const { id: subzoneListId, subZoneNames = [] } = subZonesInfo || {};

  // data
  const subZonesProcessDataObj = useSelector(
    (state) => state.zonesAndSubZones.subZonesProcessDataObj
  );
  const { isUpdate = false } = subZonesProcessDataObj || {};
  const createOrUpdateText = isUpdate ? "Update" : "Create";

  // initial update with existing subZones
  useEffect(() => {
    setSubZonesItems(subZoneNames);
  }, [subZoneNames.length]);

  // Function
  function handleSubmitForm() {
    const subZonesCSV = subZonesItems.join(",");
    onSubmit(isUpdate, subZonesCSV, subzoneListId);

    // close
    dispatch(closeCreateAndUpdateSubZonesForm());
  }

  function handleCloseForm() {
    dispatch(closeCreateAndUpdateSubZonesForm());
  }

  return (
    <div
      className="modal fade"
      id={FormDataTargets.createAndUpdateSubZonesForm}
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          {/* Form Header */}
          <div className="modal-header bg-alt px-5">
            <h4 className="modal-title">{`${createOrUpdateText} Sub Zones`}</h4>
          </div>

          {/* Form body */}
          <div className="modal-body px-5">
            <h4 className="border-bottom pb-2">Zone :: {zoneName}</h4>

            {/* Sub Zones */}
            <div className="form-group row mt-4">
              <label className="col-2 col-form-label">{"Sub Zones"}</label>
              <div className="col-10">
                <ChipsInput
                  initialChips={subZonesItems}
                  handleChange={setSubZonesItems}
                />
              </div>
            </div>
          </div>

          {/* Form Footer */}
          <div className="modal-footer px-5">
            <button
              type="button"
              className="btn btn-outline-primary btn-action mt-2 mr-3 shadow-none"
              data-dismiss="modal"
              onClick={handleCloseForm}
            >
              {"Close"}
            </button>
            <button
              type="button"
              className="btn btn-primary btn-action mt-2 shadow-none"
              data-dismiss="modal"
              onClick={handleSubmitForm}
              disabled={!isUpdate && subZonesItems.length === 0} // only in create
            >
              {createOrUpdateText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
